import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Gauge, ChevronRight, Check, X, HelpCircle, Rocket } from "lucide-react";

export default function SetupHintCard() {
  const [status, setStatus] = useState(null);
  const [helpVma, setHelpVma] = useState(false);
  const navigate = useNavigate();

  useEffect(() => { api.get("/onboarding/setup-status").then((r) => setStatus(r.data)).catch(() => {}); }, []);

  if (!status || !status.program_ready || status.dismissed) return null;
  if (status.has_vma) return null;

  const dismiss = async () => { setStatus(null); await api.post("/onboarding/dismiss-setup").catch(() => {}); };

  return (
    <div data-testid="setup-hint-card" className="fade-up rounded-2xl border border-sage/25 bg-gradient-to-br from-sage/10 via-brandblue/5 to-transparent p-6 mb-8">
      <div className="flex items-start gap-3">
        <span className="shrink-0 w-9 h-9 rounded-full bg-sage/15 flex items-center justify-center"><Rocket size={17} className="text-sage" /></span>
        <div className="flex-1 min-w-0">
          <div className="text-sm font-semibold text-obsidian">Affine ton programme en 2 minutes</div>
          <p className="mt-0.5 text-sm text-obsidian/60 leading-snug">Ton plan est prêt. Renseigne ta VMA pour des allures d'entraînement précises.</p>
        </div>
        <button data-testid="setup-hint-dismiss" onClick={dismiss} className="shrink-0 p-1 rounded-full text-obsidian/40 hover:bg-obsidian/5 transition-colors"><X size={16} /></button>
      </div>

      <div className="mt-4 space-y-2.5">
        {/* VMA */}
        <div className="rounded-xl bg-white border border-border p-4">
          <div className="flex items-center gap-3">
            <span className={`shrink-0 w-8 h-8 rounded-full flex items-center justify-center ${status.has_vma ? "bg-sage/15" : "bg-secondary"}`}>
              {status.has_vma ? <Check size={15} className="text-sage" /> : <Gauge size={15} className="text-obsidian/60" />}
            </span>
            <div className="flex-1 min-w-0">
              <div className="text-sm font-medium">Renseigner ma VMA</div>
              <div className="text-xs text-obsidian/50">{status.has_vma ? "C'est fait — tes allures sont calées" : "Indispensable pour des allures d'entraînement justes"}</div>
            </div>
            {!status.has_vma && (
              <button data-testid="setup-vma-cta" onClick={() => navigate("/profil")}
                className="shrink-0 rounded-full bg-obsidian text-white text-xs font-semibold px-3.5 py-2 inline-flex items-center gap-1 hover:-translate-y-0.5 transition-transform">
                Renseigner <ChevronRight size={13} />
              </button>
            )}
          </div>
          {!status.has_vma && (
            <>
              <button data-testid="setup-vma-help" onClick={() => setHelpVma(!helpVma)} className="mt-2 inline-flex items-center gap-1 text-xs text-sage font-medium">
                <HelpCircle size={13} /> Je ne connais pas ma VMA
              </button>
              {helpVma && (
                <div data-testid="setup-vma-help-text" className="mt-2 rounded-lg bg-secondary/60 p-3 text-xs text-obsidian/70 leading-relaxed">
                  <span className="font-medium text-obsidian">Le test demi-Cooper (6 min)</span> : après un bon échauffement, cours <span className="font-medium">6 minutes le plus vite possible et régulièrement</span> (piste ou parcours plat, avec une appli GPS). Note la <span className="font-medium">distance parcourue en mètres</span>, puis saisis-la dans Profil → VMA. Ta VMA = distance / 100 (ex : 1 500 m → 15 km/h). L'appli calcule ensuite toutes tes allures.
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
